<template>
	<main class="home">
	  <section class="home__section home__section--notifications">
	    <Notifications />
	  </section>
	</main>
</template>

<script setup>
import Notifications from '@/components/Notifications.vue';
</script>
